import { Box } from '../Box'
import { Typography } from '../Typography'
import ClipboardRemove from '../internal/svg-icons/ClipboardRemove'
import AlertTriangle from '../internal/svg-icons/AlertTriangle'
import ClipboardClose from '../internal/svg-icons/ClipboardClose'

export const NoResultFoundOverlay = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    }}
  >
    <ClipboardRemove fontSize={40} sx={{ mb: 16, textColor: 'neutral-500' }} />
    <Typography
      component={'h2'}
      variant="bodyMedium"
      weight="demi"
      lineHeight="single-line"
      sx={{ mb: 8 }}
    >
      No results found
    </Typography>
    <Typography component={'p'} variant="bodySmall" gutterBottom={false}>
      We can’t find any items matching your search
    </Typography>
  </Box>
)

export const ErrorOverlay = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    }}
  >
    <AlertTriangle fontSize={40} sx={{ mb: 16, textColor: 'neutral-500' }} />
    <Typography component={'p'} variant="bodySmall" gutterBottom={false}>
      Oops, something went wrong. Please try again after some time.
    </Typography>
  </Box>
)

export const NoRowsOverlay = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    }}
  >
    <ClipboardClose fontSize={40} sx={{ mb: 16, textColor: 'neutral-500' }} />
    <Typography component={'p'} variant="bodySmall" gutterBottom={false}>
      At the moment, there's no content to display here.
    </Typography>
  </Box>
)
